import type { ActiveHoliday, ActiveThemeName } from '@web/src/theme'
import { createContext, useContext } from 'react'

type ColorSchemeContextValue = {
  /** Theme applied to the document, such as `light`, `dark`, or `halloween`. */
  themeName: ActiveThemeName
  /** Public holiday on the calendar, independent of the applied theme. */
  activeHoliday: ActiveHoliday
}

const ColorSchemeContext = createContext<ColorSchemeContextValue>({ themeName: 'dark', activeHoliday: null })

export const ColorSchemeProvider = ({
  themeName,
  activeHoliday,
  children,
}: {
  themeName: ActiveThemeName
  activeHoliday: ActiveHoliday
  children: React.ReactNode
}) => <ColorSchemeContext.Provider value={{ themeName, activeHoliday }}>{children}</ColorSchemeContext.Provider>

export const useColorScheme = () => useContext(ColorSchemeContext)
